import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { API_CLINIC_REVIEW_TIME } from 'services/dataService/resources';

export const useClinicReviewTimeModalData = () => {
  const { data, isLoading, isError, error, remove } = useQuery({
    queryKey: ['clinicReviewTimeModalData'],
    queryFn: getClinicReviewTimeData,
  });

  return {
    data,
    isLoading,
    remove,
    isError,
    error,
  };
};

export interface ClinicReviewTimeData {
  clinicGuid: string;
  clinicName: string;
  reviewTimeSeconds: number;
  childClinicsCount: number;
}

const getClinicReviewTimeData = async () => {
  const { data, error } = await dataService.getList<ClinicReviewTimeData[]>(
    API_CLINIC_REVIEW_TIME,
  );

  if (error) {
    throw new Error(error);
  }

  return data || [];
};
